'use client'

import { useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

interface ScreenTransitionProps {
  children: React.ReactNode
}

export default function ScreenTransition({ children }: ScreenTransitionProps) {
  const [isVisible, setIsVisible] = useState(true)
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 })

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setMousePosition({ x: e.clientX, y: e.clientY })
    }

    // 只在页面加载和卸载时显示过渡效果，不在滚动时触发
    const handleBeforeUnload = () => {
      setIsVisible(false)
    }

    document.addEventListener('mousemove', handleMouseMove)
    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      document.removeEventListener('mousemove', handleMouseMove)
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [])

  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{
          duration: 0.8,
          ease: [0.43, 0.13, 0.23, 0.96]
        }}
        className="min-h-screen"
      >
        {children}
      </motion.div>

      {/* 页面切换粒子效果 - 只在页面切换时显示 */}
      <ParticleEffect isVisible={isVisible} />
    </>
  )
}

// 粒子效果组件
function ParticleEffect({ isVisible }: { isVisible: boolean }) {
  const particles = Array.from({ length: 30 }, (_, i) => ({
    id: i,
    x: Math.random() * 100,
    y: Math.random() * 100,
    delay: Math.random() * 0.3,
    duration: Math.random() * 0.8 + 0.8,
    size: Math.random() * 3 + 1,
  }))

  return (
    <AnimatePresence>
      {!isVisible && (
        <motion.div
          key="particles"
          className="fixed inset-0 pointer-events-none z-40"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
        >
          {particles.map((particle) => (
            <motion.div
              key={particle.id}
              className="absolute rounded-full bg-orange-300/70"
              style={{
                left: `${particle.x}%`,
                top: `${particle.y}%`,
                width: particle.size,
                height: particle.size,
              }}
              initial={{ 
                scale: 0, 
                opacity: 0.8,
                x: 0,
                y: 0,
              }}
              animate={{ 
                scale: [0, 0.8, 0],
                opacity: [0.8, 0.6, 0],
                x: (Math.random() - 0.5) * 150,
                y: (Math.random() - 0.5) * 150,
              }}
              transition={{
                duration: particle.duration,
                delay: particle.delay,
                ease: "easeOut"
              }}
            />
          ))}
        </motion.div>
      )}
    </AnimatePresence>
  )
}